import { resourcePropertyProvider, Resources } from '@40seas/frontend/dashboard/providers';
import { SetupStripe } from '@40seas/frontend/libs/entities';
import type { Stripe } from '@stripe/stripe-js';
import { stripeLoadingProvider } from 'frontend/libs/components/payments-shared/src/lib/providers/stripeLoadingProvider';
import { useDataProvider } from 'react-admin';
import DefaultDataProvider from '../providers/defaultDataProvider';

export const useInitStripe = () => {
    const dataProvider = useDataProvider() as DefaultDataProvider;

    if (!window.stripePromise) {
        window.stripePromise = async ({ tenantId, token, useConnectedAccount = true }) => {
            const headers = {
                ...(tenantId ? { '40seas-tenant': tenantId } : {}),
                ...(token ? { '40seas-token': token } : {}),
            };
            if (!window.stripeSetup) {
                const { data: stripeSetup } = await dataProvider.getResourceProperty(
                    Resources.Configs,
                    resourcePropertyProvider.configs.getStripePublicKey(),
                    undefined,
                    { headers },
                );

                window.stripeSetup = stripeSetup;
            }

            return stripeLoadingProvider(useConnectedAccount);
        };
    }

    return window.stripePromise;
};

declare global {
    interface Window {
        stripePromise: (options: {
            tenantId?: string;
            token?: string;
            useConnectedAccount?: boolean;
        }) => Promise<Stripe | null | void> | null;
        stripeSetup: SetupStripe;
    }
}
